// API Configuration
//
// Default to a RELATIVE '/api' so the browser talks to its own origin and the
// CRA dev proxy (package.json "proxy") forwards to the backend. This keeps the
// auth cookie first-party in dev regardless of whether the app is opened at
// localhost or 127.0.0.1 (cross-site cookies would otherwise be withheld).
// In production, set REACT_APP_API_URL to the absolute API URL at build time.
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    SIGNUP: '/auth/register',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    VERIFY_EMAIL: (token: string) => `/auth/verify-email/${token}`,
    RESEND_VERIFICATION: '/auth/resend-verification',
  },
  // Room endpoints
  ROOMS: {
    GET_ALL: '/rooms',
    GET_AVAILABLE: '/rooms/available',
    GET_BY_NUMBER: (roomNumber: number) => `/rooms/${roomNumber}`,
    CHECK_AVAILABILITY: (roomNumber: number, bedNumber: number) => 
      `/rooms/${roomNumber}/availability?bedNumber=${bedNumber}`,
  },
  // Booking endpoints
  BOOKINGS: {
    CREATE: '/bookings',
    GET_ALL: '/bookings',
    GET_BY_ID: (id: string) => `/bookings/${id}`,
    CANCEL: (id: string) => `/bookings/${id}`,
    DELETE: (id: string) => `/bookings/${id}/delete`,
    UPDATE_STATUS: (id: string) => `/bookings/${id}/status`,
    CONFIRM_PAYMENT: (id: string) => `/bookings/${id}/confirm-payment`,
    GET_STATS: '/bookings/stats',
    RELEASE_BED: (roomNumber: number, bedNumber: number) =>
      `/bookings/rooms/${roomNumber}/beds/${bedNumber}/occupant`,
  },
  // User endpoints
  USERS: {
    GET_PROFILE: '/users/profile',
    UPDATE_PROFILE: '/users/profile',
    GET_BOOKINGS: '/users/bookings',
  },
  // Admin endpoints
  ADMIN: {
    GET_CONFIG: '/admin/config',
    UPDATE_CONFIG: '/admin/config',
    GENERATE_ROOMS: '/admin/rooms/generate',
    INCREASE_ROOMS: '/admin/rooms/increase',
    UPDATE_ROOM_STATUS: (id: string) => `/admin/rooms/${id}/status`,
    GET_AUDIT_LOGS: '/admin/audit-logs',
    GET_USERS: '/admin/users',
    GET_USER_DETAILS: (id: string) => `/admin/users/${id}`,
    GET_USER_STATS: '/admin/users/stats',
    EXPORT_USERS_CSV: '/admin/users/export/csv',
    UPDATE_USER_ROLE: (id: string) => `/admin/users/${id}/role`,
  },
  // Public config endpoints (no auth)
  CONFIG: {
    BOOKING_STATUS: '/config/booking-status',
  },
  // Announcement endpoints
  ANNOUNCEMENTS: {
    GET_ALL: '/announcements',
    GET_ADMIN: '/announcements/admin',
    CREATE: '/announcements',
    UPDATE: (id: string) => `/announcements/${id}`,
    DELETE: (id: string) => `/announcements/${id}`,
    MARK_READ: (id: string) => `/announcements/${id}/read`,
    MARK_UNREAD: (id: string) => `/announcements/${id}/read`,
    CLEAR_ALL: '/announcements/clear-all',
    CLEAR_READ: '/announcements/clear-read',
    GET_STUDENTS: '/announcements/students',
  },
  // Complaint / Suggestion Box endpoints
  COMPLAINTS: {
    CREATE: '/complaints',
  },
  // Payment receipt endpoints
  RECEIPTS: {
    UPLOAD: '/receipts',
    GET_MINE: '/receipts/me',
    GET_ALL: '/receipts',
    REVIEW: (id: string) => `/receipts/${id}`,
    CLEAR: (id: string) => `/receipts/${id}/clear`,
    CLEAR_REVIEWED: '/receipts/clear-reviewed',
  },
  // Access Code endpoints
  ACCESS_CODES: {
    REDEEM: '/access-codes/redeem',
    GENERATE: '/access-codes/generate',
    GET_ALL: '/access-codes',
    GET_STATS: '/access-codes/stats',
  },
};